import { render, staticRenderFns } from "./ModalZeresima.vue?vue&type=template&id=4f3a3fb4&scoped=true"
import script from "./ModalZeresima.vue?vue&type=script&lang=js"
export * from "./ModalZeresima.vue?vue&type=script&lang=js"
import style0 from "./ModalZeresima.vue?vue&type=style&index=0&id=4f3a3fb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3a3fb4",
  null
  
)

export default component.exports